import { Chip, PropTypes, createStyles, makeStyles, Theme } from '@material-ui/core';
import { addSeconds, differenceInSeconds } from 'date-fns';
import useCountdown from 'hooks/useCountdown';
import React from 'react';

export interface ICountdownTimer {
  counter: number,
  color?: PropTypes.Color,
  onProgress?: (counter: number) => void,
  onCompleted?: Function,
  disabled?: boolean,
  className?: string
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minWidth: '90px'
    },
  }),
);

export default ({
  counter,
  color,
  onProgress,
  onCompleted,
  disabled,
  className
}: ICountdownTimer) => {
  const classes = useStyles();
  const countdown = useCountdown(counter, null, onProgress, onCompleted);
  const fixedDate = new Date(2020, 0, 1, 0, 0, 0);

  const formatDuration = (start: Date, finish: Date) => {
    const diffTime = differenceInSeconds(finish, start);
    if (!diffTime) return '00:00:00';
    const seconds = Number(diffTime) % 60;
    const minutes = Math.abs(Math.floor(diffTime / 60) % 60).toString();
    const hours = Math.abs(Math.floor(diffTime / 60 / 60)).toString();
    return `${hours.length < 2 ? '0' + hours : hours}:${minutes.length < 2 ? '0' + minutes : minutes}:${seconds.toString().length < 2 ? '0' + seconds : seconds}`;
};

  return (
    <Chip
      label={

        formatDuration(
          fixedDate,
          addSeconds(fixedDate, countdown.counter)
        )
      }
      color={ color }
      className={ classes.root + ' ' + className }
      disabled={ disabled }
    />
  );
}